// removed by extract-text-webpack-plugin
module.exports = {"overview":"_3jnkzZgBIUC8YblpZ7V-e__0","body":"_298kh8D1D6eDPzGPOQsk2A_0","block":"_2qmsaWfZ7DX5x6zwpuIdnh_0","short":"jTM15anB9rhhlkqesDatu_0"};


//////////////////
// WEBPACK FOOTER
// ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"sourceMap":true,"localIdentName":"[hash:base64]_0","importLoaders":true,"modules":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-0d340966","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Overview/index.vue
// module id = XotS
// module chunks = 1